import React from "react";
import {
  StyleSheet,
  View,
  Dimensions,
  Text,
  TouchableHighlight,
} from "react-native";

const actualWidth = Dimensions.get("screen").width;
const Index = (props) => {
  return (
    <View style={styles.container}>
      <Text style={styles.content}>
        Now, answer the following questions with{" "}
        <Text style={{ fontWeight: "var(--font-weight-bold)" }}>True</Text> or{" "}
        <Text style={{ fontWeight: "var(--font-weight-bold)" }}>False</Text>,
        and let us know how sure you are.{`\n`}
        {`\n`}If you don’t know, take a guess!
      </Text>

      <View style={styles.buttonContainer}>
        <TouchableHighlight
          style={styles.continueButton}
          onPress={() => {
            props.navigation();
          }}
        >
          <Text style={styles.continueText}>OK, GOT IT!</Text>
        </TouchableHighlight>
      </View>
    </View>
  );
};
export default Index;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  content: {
    textAlign: "center",
    fontWeight: "var(--font-weight-thin)",
    color: "var(--text-color-alternate)",
    fontSize: "var(--module-detail-font-size)",
    width: "var(--module-detail-width)",
    letterSpacing: "var(--module-detail-letter-spacing)",
  },

  button: {
    height: "auto",
    width: "auto",
    backgroundColor: "#575f69",
    borderRadius: 3,
    justifyContent: "center",
    paddingHorizontal: 15,
    paddingTop: actualWidth === 414 || actualWidth === 834 ? 15 : 10,
    paddingBottom: actualWidth === 414 ? 15 : 10,
  },

  buttonText: {
    fontSize: 16,
    textAlign: "center",
    letterSpacing: 1.5,
    color: "#ffffff",
  },

  buttonContainer: {
    top: 25,
  },
  continueButton: {
    height: 48,
    backgroundColor: "var(--button-background-color-default)",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    textTransform: "uppercase",
  },
  continueText: {
    paddingLeft: "var(--button-padding-left)",
    paddingRight: "var(--button-padding-right)",
    fontSize: "var(--module-detail-button-font-size)",
    fontStyle: "normal",
    textAlign: "center",
    color: "var(--button-color-default)",
    fontWeight: "var(--font-weight-bold)",
    lineHeight: "normal",
    letterSpacing: "var(--button-letter-spacing)",
  },
});
